define(function(require) {
    // RESEAU_PPS themeSetsElements definition config
    return  {
        ID : "RESEAU_PPS",
        TYPE : "ThemeSetGroup",
        TITLE : "Établissements scolaires publics",
        THEMESETS_ELEMENTS : [
            {
                ID : "SZ_RESEAU_FRANCO_ALL",
                TYPE : "ThemeSet",
                TITLE : "Ensemble des établissements scolaires francophones",
                SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                THEMESET_MAP_SETTINGS : {
                    LAYERS_SETTINGS : [
                        {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                        {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                    ]
                },
                THEMES: [{
                        TYPE: "ThemeByRangesOfValues",
                        LAYER_ID: "BC_taux",
                        DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                        DATACOLUMN_ID: "c_TAUX_PRES",
                        REPRESENTATION_ENUM: "color",
                        AS_OVERLAY: false,
                        ENABLED: true,
                        LEGEND_TEXT: "Taux de couverture 2025 (%)",
                        NUMBER_OF_RANGES: 8,
                        RANGE_CALCULATION_METHOD: "CUSTOM",
                        REVERSE_RANGES: true,
                        REVERSE_REPRESENTATIONS: true,
                        SCHEME: {
                            ID: "T20_TAUX_PRES_RANGES_OF_VALUES_FR",
                            SCHEME_ELEMENTS: [{
                                MIN_VALUE: 0,
                                MAX_VALUE: 85,
                                REPRESENTATION: "rgba(236,98,98,1)",
                                LEGEND_TEXT: "Déficit fort (moins de 85%)"
                            }, {
                                MIN_VALUE: 85,
                                MAX_VALUE: 90,
                                REPRESENTATION: "rgba(240,140,140,1)",
                                LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                            }, {
                                MIN_VALUE: 90,
                                MAX_VALUE: 95,
                                REPRESENTATION: "rgba(247,193,193,1)",
                                LEGEND_TEXT: "Déficit faible (90% à 94%)"
                            }, {
                                MIN_VALUE: 95,
                                MAX_VALUE: 100,
                                REPRESENTATION: "rgba(251,225,225,1)",
                                LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                            }, {
                                MIN_VALUE: 100,
                                MAX_VALUE: 106,
                                REPRESENTATION: "rgba(226,239,217,1)",
                                LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                            }, {
                                MIN_VALUE: 106,
                                MAX_VALUE: 111,
                                REPRESENTATION: "rgba(198,224,180,1)",
                                LEGEND_TEXT: "Surplus faible (106% à 110%)"
                            }, {
                                MIN_VALUE: 111,
                                MAX_VALUE: 116,
                                REPRESENTATION: "rgba(160,204,130,1)",
                                LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                            }, {
                                MIN_VALUE: 116,
                                MAX_VALUE: 300,
                                REPRESENTATION: "rgba(117,179,75,1)",
                                LEGEND_TEXT: "Surplus fort (116% et plus)"
                            }]
                        }
                    },
                    {
                        TYPE: "ThemeByRangesOfValues",
                        LAYER_ID: "BC_taux_1",
                        DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                        DATACOLUMN_ID: "c_TAUX_ANTIC",
                        REPRESENTATION_ENUM: "color",
                        AS_OVERLAY: false,
                        ENABLED: true,
                        LEGEND_TEXT: "Taux de couverture 2028 (%)",
                        NUMBER_OF_RANGES: 8,
                        RANGE_CALCULATION_METHOD: "CUSTOM",
                        REVERSE_RANGES: true,
                        REVERSE_REPRESENTATIONS: true,
                        SCHEME: {
                            ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_FR",
                            SCHEME_ELEMENTS: [{
                                MIN_VALUE: 0,
                                MAX_VALUE: 85,
                                REPRESENTATION: "rgba(236,98,98,1)",
                                LEGEND_TEXT: "Déficit fort (moins de 85%)"
                            }, {
                                MIN_VALUE: 85,
                                MAX_VALUE: 90,
                                REPRESENTATION: "rgba(240,140,140,1)",
                                LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                            }, {
                                MIN_VALUE: 90,
                                MAX_VALUE: 95,
                                REPRESENTATION: "rgba(247,193,193,1)",
                                LEGEND_TEXT: "Déficit faible (90% à 94%)"
                            }, {
                                MIN_VALUE: 95,
                                MAX_VALUE: 100,
                                REPRESENTATION: "rgba(251,225,225,1)",
                                LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                            }, {
                                MIN_VALUE: 100,
                                MAX_VALUE: 106,
                                REPRESENTATION: "rgba(226,239,217,1)",
                                LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                            }, {
                                MIN_VALUE: 106,
                                MAX_VALUE: 111,
                                REPRESENTATION: "rgba(198,224,180,1)",
                                LEGEND_TEXT: "Surplus faible (106% à 110%)"
                            }, {
                                MIN_VALUE: 111,
                                MAX_VALUE: 116,
                                REPRESENTATION: "rgba(160,204,130,1)",
                                LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                            }, {
                                MIN_VALUE: 116,
                                MAX_VALUE: 300,
                                REPRESENTATION: "rgba(117,179,75,1)",
                                LEGEND_TEXT: "Surplus fort (116% et plus)"
                            }]
                        }
                    }
                ]
            },  /*{
                ID : "SZ_RESEAU_FRANCO_MAT4ANS",
                TYPE : "ThemeSet",
                TITLE : "Ensemble des établissements scolaires francophones",
                SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                THEMESET_MAP_SETTINGS : {
                    LAYERS_SETTINGS : [
                        {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                        {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                    ]
                }
            },*/  {
                ID : "RESEAU_FRANCO_CS",
                TYPE : "ThemeSetGroup",
                TITLE : "Par centres de services scolaires francophones et avec présence de classe maternelle 4 ans à temps plein",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "RESEAU_FRANCO_CS_711000",
                        TYPE : "ThemeSet",
                        TITLE : "711000 - CSS des Monts-et-Marées",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "711000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "711000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "711000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_711",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_711",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_712000",
                        TYPE : "ThemeSet",
                        TITLE : "712000 - CSS des Phares",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "712000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "712000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "712000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_712",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_712",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_713000",
                        TYPE : "ThemeSet",
                        TITLE : "713000 - CSS du Fleuve-et-des-Lacs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "713000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "713000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "713000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_713",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_713",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_714000",
                        TYPE : "ThemeSet",
                        TITLE : "714000 - CSS de Kamouraska-Rivière-du-Loup",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "714000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "714000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "714000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_714",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_714",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_721000",
                        TYPE : "ThemeSet",
                        TITLE : "721000 - CSS du Pays-des-Bleuets",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "721000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "721000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "721000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_721",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_721",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_722000",
                        TYPE : "ThemeSet",
                        TITLE : "722000 - CSS du Lac-Saint-Jean",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "722000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "722000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "722000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_722",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_722",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_723000",
                        TYPE : "ThemeSet",
                        TITLE : "723000 - CSS des Rives-du-Saguenay",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "723000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "723000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "723000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_723",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_723",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_724000",
                        TYPE : "ThemeSet",
                        TITLE : "724000 - CSS De La Jonquière",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "724000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "724000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "724000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_724",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_724",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_731000",
                        TYPE : "ThemeSet",
                        TITLE : "731000 - CSS de Charlevoix",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "731000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "731000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "731000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_731",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_731",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_732000",
                        TYPE : "ThemeSet",
                        TITLE : "732000 - CSS de la Capitale",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "732000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "732000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "732000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_732",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_732",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_733000",
                        TYPE : "ThemeSet",
                        TITLE : "733000 - CSS des Découvreurs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "733000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "733000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "733000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_733",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_733",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_734000",
                        TYPE : "ThemeSet",
                        TITLE : "734000 - CSS des Premières-Seigneuries",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "734000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "734000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "734000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_734",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_734",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_735000",
                        TYPE : "ThemeSet",
                        TITLE : "735000 - CSS de Portneuf",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "735000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "735000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "735000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_735",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_735",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_741000",
                        TYPE : "ThemeSet",
                        TITLE : "741000 - CSS du Chemin-du-Roy",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "741000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "741000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "741000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_741",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_741",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_742000",
                        TYPE : "ThemeSet",
                        TITLE : "742000 - CSS de l'Énergie",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "742000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "742000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "742000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_742",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_742",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_751000",
                        TYPE : "ThemeSet",
                        TITLE : "751000 - CSS des Hauts-Cantons",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "751000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "751000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "751000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_751",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_751",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_752000",
                        TYPE : "ThemeSet",
                        TITLE : "752000 - CSS de la Région-de-Sherbrooke",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "752000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "752000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "752000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_752",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_752",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_753000",
                        TYPE : "ThemeSet",
                        TITLE : "753000 - CSS des Sommets",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "753000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "753000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "753000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_753",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_753",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_761000",
                        TYPE : "ThemeSet",
                        TITLE : "761000 - CSS de la Pointe-de-l'Île",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "761000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "761000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "761000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_761",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_761",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_762000",
                        TYPE : "ThemeSet",
                        TITLE : "762000 - CSS de Montréal",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "762000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "762000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "762000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_762",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_762",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_763000",
                        TYPE : "ThemeSet",
                        TITLE : "763000 - CSS Marguerite-Bourgeoys",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "763000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "763000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "763000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_763",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_763",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_771000",
                        TYPE : "ThemeSet",
                        TITLE : "771000 - CSS des Draveurs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "771000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "771000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "771000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_771",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_771",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_772000",
                        TYPE : "ThemeSet",
                        TITLE : "772000 - CSS des Portages-de-l'Outaouais",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "772000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "772000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "772000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_772",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_772",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_773000",
                        TYPE : "ThemeSet",
                        TITLE : "773000 - CSS au Coeur-des-Vallées",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "773000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "773000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "773000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_773",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_773",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_774000",
                        TYPE : "ThemeSet",
                        TITLE : "774000 - CSS des Hauts-Bois-de-l'Outaouais",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "774000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "774000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "774000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_774",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_774",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_781000",
                        TYPE : "ThemeSet",
                        TITLE : "781000 - CSS du Lac-Témiscamingue",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "781000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "781000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "781000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_781",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_781",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_782000",
                        TYPE : "ThemeSet",
                        TITLE : "782000 - CSS de Rouyn-Noranda",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "782000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "782000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "782000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_782",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_782",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_783000",
                        TYPE : "ThemeSet",
                        TITLE : "783000 - CSS Harricana",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "783000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "783000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "783000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_783",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_783",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_784000",
                        TYPE : "ThemeSet",
                        TITLE : "784000 - CSS de l'Or-et-des-Bois",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "784000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "784000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "784000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_784",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_784",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_785000",
                        TYPE : "ThemeSet",
                        TITLE : "785000 - CSS du Lac-Abitibi",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "785000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "785000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "785000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_785",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_785",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_791000",
                        TYPE : "ThemeSet",
                        TITLE : "791000 - CSS de l'Estuaire",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "791000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "791000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "791000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_791",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_791",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_792000",
                        TYPE : "ThemeSet",
                        TITLE : "792000 - CSS du Fer",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "792000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "792000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "792000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_792",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_792",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_793000",
                        TYPE : "ThemeSet",
                        TITLE : "793000 - CSS de la Moyenne-Côte-Nord",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "793000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "793000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "793000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_793",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_793",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_801000",
                        TYPE : "ThemeSet",
                        TITLE : "801000 - CSS de la Baie-James",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "801000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "801000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "801000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_801",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_801",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_811000",
                        TYPE : "ThemeSet",
                        TITLE : "811000 - CSS des Îles",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "811000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "811000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "811000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_811",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_811",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_812000",
                        TYPE : "ThemeSet",
                        TITLE : "812000 - CSS des Chic-Chocs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "812000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "812000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "812000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_812",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_812",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_813000",
                        TYPE : "ThemeSet",
                        TITLE : "813000 - CSS René-Lévesque",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "813000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "813000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "813000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_813",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_813",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_821000",
                        TYPE : "ThemeSet",
                        TITLE : "821000 - CSS de la Côte-du-Sud",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "821000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "821000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "821000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_821",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_821",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_822000",
                        TYPE : "ThemeSet",
                        TITLE : "822000 - CSS des Appalaches",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "822000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "822000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "822000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_822",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_822",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_823000",
                        TYPE : "ThemeSet",
                        TITLE : "823000 - CSS de la Beauce-Etchemin",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "823000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "823000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "823000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_823",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_823",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_824000",
                        TYPE : "ThemeSet",
                        TITLE : "824000 - CSS des Navigateurs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "824000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "824000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "824000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_824",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_824",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_831000",
                        TYPE : "ThemeSet",
                        TITLE : "831000 - CSS de Laval",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "831000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "831000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "831000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_831",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_831",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_841000",
                        TYPE : "ThemeSet",
                        TITLE : "841000 - CSS des Affluents",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "841000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "841000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "841000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_841",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_841",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_842000",
                        TYPE : "ThemeSet",
                        TITLE : "842000 - CSS des Samares",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "842000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "842000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "842000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_842",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_842",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_851000",
                        TYPE : "ThemeSet",
                        TITLE : "851000 - CSS des Mille-Îles",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "851000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "851000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "851000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_851",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_851",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_852000",
                        TYPE : "ThemeSet",
                        TITLE : "852000 - CSS de la Rivière-du-Nord",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "852000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "852000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "852000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_852",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_852",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_853000",
                        TYPE : "ThemeSet",
                        TITLE : "853000 - CSS des Laurentides",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "853000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "853000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "853000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_853",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_853",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_854000",
                        TYPE : "ThemeSet",
                        TITLE : "854000 - CSS des Hautes-Laurentides",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "854000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "854000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "854000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_854",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_854",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_861000",
                        TYPE : "ThemeSet",
                        TITLE : "861000 - CSS de Sorel-Tracy",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "861000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "861000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "861000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_861",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_861",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_862000",
                        TYPE : "ThemeSet",
                        TITLE : "862000 - CSS de Saint-Hyacinthe",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "862000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "862000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "862000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_862",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_862",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_863000",
                        TYPE : "ThemeSet",
                        TITLE : "863000 - CSS des Hautes-Rivières",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "863000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "863000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "863000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_863",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_863",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_864000",
                        TYPE : "ThemeSet",
                        TITLE : "864000 - CSS Marie-Victorin",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "864000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "864000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "864000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_864",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_864",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_865000",
                        TYPE : "ThemeSet",
                        TITLE : "865000 - CSS des Patriotes",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "865000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "865000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "865000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_865",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_865",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_866000",
                        TYPE : "ThemeSet",
                        TITLE : "866000 - CSS du Val-des-Cerfs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "866000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "866000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "866000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_866",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_866",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_867000",
                        TYPE : "ThemeSet",
                        TITLE : "867000 - CSS des Grandes-Seigneuries",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "867000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "867000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "867000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_867",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_867",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_868000",
                        TYPE : "ThemeSet",
                        TITLE : "868000 - CSS de la Vallée-des-Tisserands",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "868000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "868000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "868000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_868",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_868",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_869000",
                        TYPE : "ThemeSet",
                        TITLE : "869000 - CSS des Trois-Lacs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "869000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "869000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "869000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_869",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_869",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_871000",
                        TYPE : "ThemeSet",
                        TITLE : "871000 - CSS de la Riveraine",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "871000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "871000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "871000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_871",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_871",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_872000",
                        TYPE : "ThemeSet",
                        TITLE : "872000 - CSS des Bois-Francs",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "872000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "872000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "872000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_872",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_872",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_FRANCO_CS_873000",
                        TYPE : "ThemeSet",
                        TITLE : "873000 - CSS des Chênes",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_FRANCO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSF_MAT4ANS", DATATABLE_ID : "t_CSF_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "873000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_FRANCO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_FRANCO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "873000"}]},
                                {LAYER_ID : "GEO09E01_CS_FRA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E01_CS_FRA_GEN", DATACOLUMN_ID : "CD_CS_FRA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "873000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_873",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_873",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }
                ]
            },  {
                ID : "SZ_RESEAU_ANGLO_ALL",
                TYPE : "ThemeSet",
                TITLE : "Ensemble des établissements scolaires anglophones",
                SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                THEMESET_MAP_SETTINGS : {
                    LAYERS_SETTINGS : [
                        {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                        {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                    ]
                },
                THEMES: [{
                        TYPE: "ThemeByRangesOfValues",
                        LAYER_ID: "BC_taux",
                        DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                        DATACOLUMN_ID: "c_TAUX_PRES",
                        REPRESENTATION_ENUM: "color",
                        AS_OVERLAY: false,
                        ENABLED: true,
                        LEGEND_TEXT: "Taux de couverture 2025 (%)",
                        NUMBER_OF_RANGES: 8,
                        RANGE_CALCULATION_METHOD: "CUSTOM",
                        REVERSE_RANGES: true,
                        REVERSE_REPRESENTATIONS: true,
                        SCHEME: {
                            ID: "T20_TAUX_PRES_RANGES_OF_VALUES_AN",
                            SCHEME_ELEMENTS: [{
                                MIN_VALUE: 0,
                                MAX_VALUE: 85,
                                REPRESENTATION: "rgba(236,98,98,1)",
                                LEGEND_TEXT: "Déficit fort (moins de 85%)"
                            }, {
                                MIN_VALUE: 85,
                                MAX_VALUE: 90,
                                REPRESENTATION: "rgba(240,140,140,1)",
                                LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                            }, {
                                MIN_VALUE: 90,
                                MAX_VALUE: 95,
                                REPRESENTATION: "rgba(247,193,193,1)",
                                LEGEND_TEXT: "Déficit faible (90% à 94%)"
                            }, {
                                MIN_VALUE: 95,
                                MAX_VALUE: 100,
                                REPRESENTATION: "rgba(251,225,225,1)",
                                LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                            }, {
                                MIN_VALUE: 100,
                                MAX_VALUE: 106,
                                REPRESENTATION: "rgba(226,239,217,1)",
                                LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                            }, {
                                MIN_VALUE: 106,
                                MAX_VALUE: 111,
                                REPRESENTATION: "rgba(198,224,180,1)",
                                LEGEND_TEXT: "Surplus faible (106% à 110%)"
                            }, {
                                MIN_VALUE: 111,
                                MAX_VALUE: 116,
                                REPRESENTATION: "rgba(160,204,130,1)",
                                LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                            }, {
                                MIN_VALUE: 116,
                                MAX_VALUE: 300,
                                REPRESENTATION: "rgba(117,179,75,1)",
                                LEGEND_TEXT: "Surplus fort (116% et plus)"
                            }]
                        }
                    },
                    {
                        TYPE: "ThemeByRangesOfValues",
                        LAYER_ID: "BC_taux_1",
                        DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                        DATACOLUMN_ID: "c_TAUX_ANTIC",
                        REPRESENTATION_ENUM: "color",
                        AS_OVERLAY: false,
                        ENABLED: true,
                        LEGEND_TEXT: "Taux de couverture 2028 (%)",
                        NUMBER_OF_RANGES: 8,
                        RANGE_CALCULATION_METHOD: "CUSTOM",
                        REVERSE_RANGES: true,
                        REVERSE_REPRESENTATIONS: true,
                        SCHEME: {
                            ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_AN",
                            SCHEME_ELEMENTS: [{
                                MIN_VALUE: 0,
                                MAX_VALUE: 85,
                                REPRESENTATION: "rgba(236,98,98,1)",
                                LEGEND_TEXT: "Déficit fort (moins de 85%)"
                            }, {
                                MIN_VALUE: 85,
                                MAX_VALUE: 90,
                                REPRESENTATION: "rgba(240,140,140,1)",
                                LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                            }, {
                                MIN_VALUE: 90,
                                MAX_VALUE: 95,
                                REPRESENTATION: "rgba(247,193,193,1)",
                                LEGEND_TEXT: "Déficit faible (90% à 94%)"
                            }, {
                                MIN_VALUE: 95,
                                MAX_VALUE: 100,
                                REPRESENTATION: "rgba(251,225,225,1)",
                                LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                            }, {
                                MIN_VALUE: 100,
                                MAX_VALUE: 106,
                                REPRESENTATION: "rgba(226,239,217,1)",
                                LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                            }, {
                                MIN_VALUE: 106,
                                MAX_VALUE: 111,
                                REPRESENTATION: "rgba(198,224,180,1)",
                                LEGEND_TEXT: "Surplus faible (106% à 110%)"
                            }, {
                                MIN_VALUE: 111,
                                MAX_VALUE: 116,
                                REPRESENTATION: "rgba(160,204,130,1)",
                                LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                            }, {
                                MIN_VALUE: 116,
                                MAX_VALUE: 300,
                                REPRESENTATION: "rgba(117,179,75,1)",
                                LEGEND_TEXT: "Surplus fort (116% et plus)"
                            }]
                        }
                    }
                ]
            },  {
                ID : "RESEAU_ANGLO_CS",
                TYPE : "ThemeSetGroup",
                TITLE : "Par commissions scolaires anglophones et avec présence de classe maternelle 4 ans à temps plein",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "RESEAU_ANGLO_CS_881000",
                        TYPE : "ThemeSet",
                        TITLE : "881000 - CS Central Québec",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "881000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "881000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "881000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_881",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_881",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_882000",
                        TYPE : "ThemeSet",
                        TITLE : "882000 - CS Eastern Shores",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "882000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "882000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "882000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_882",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_882",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_883000",
                        TYPE : "ThemeSet",
                        TITLE : "883000 - CS Eastern Townships",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "883000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "883000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "883000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_883",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_883",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_884000",
                        TYPE : "ThemeSet",
                        TITLE : "884000 - CS Riverside",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "884000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "884000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "884000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_884",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_884",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_885000",
                        TYPE : "ThemeSet",
                        TITLE : "885000 - CS Sir-Wilfrid-Laurier",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "885000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "885000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "885000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_885",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_885",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_886000",
                        TYPE : "ThemeSet",
                        TITLE : "886000 - CS Western Québec",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "886000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "886000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "886000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_886",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_886",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_887000",
                        TYPE : "ThemeSet",
                        TITLE : "887000 - CS English-Montréal",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "887000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "887000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "887000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_887",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_887",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_888000",
                        TYPE : "ThemeSet",
                        TITLE : "888000 - CS Lester-B.-Pearson",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "888000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "888000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "888000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_888",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_888",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_ANGLO_CS_889000",
                        TYPE : "ThemeSet",
                        TITLE : "889000 - CS New Frontiers",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_ANGLO",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSA_MAT4ANS", DATATABLE_ID : "t_CSA_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "889000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_ANGLO", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_ANGLO", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "889000"}]},
                                {LAYER_ID : "GEO09E02_CS_ANG_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E02_CS_ANG_GEN", DATACOLUMN_ID : "CD_CS_ANG", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "889000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_889",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_889",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }
                ]
            }, {
                ID : "SZ_RESEAU_STATUT_ALL",
                TYPE : "ThemeSet",
                TITLE : "Ensemble des établissements scolaires à statut particulier",
                SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_STATUT",
                SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                THEMESET_MAP_SETTINGS : {
                    LAYERS_SETTINGS : [
                        {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                        {LAYER_ID : "GEO09E03_CS_STA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                    ]
                },
                THEMES: [{
                        TYPE: "ThemeByRangesOfValues",
                        LAYER_ID: "BC_taux",
                        DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                        DATACOLUMN_ID: "c_TAUX_PRES",
                        REPRESENTATION_ENUM: "color",
                        AS_OVERLAY: false,
                        ENABLED: true,
                        LEGEND_TEXT: "Taux de couverture 2025 (%)",
                        NUMBER_OF_RANGES: 8,
                        RANGE_CALCULATION_METHOD: "CUSTOM",
                        REVERSE_RANGES: true,
                        REVERSE_REPRESENTATIONS: true,
                        SCHEME: {
                            ID: "T20_TAUX_PRES_RANGES_OF_VALUES_ST",
                            SCHEME_ELEMENTS: [{
                                MIN_VALUE: 0,
                                MAX_VALUE: 85,
                                REPRESENTATION: "rgba(236,98,98,1)",
                                LEGEND_TEXT: "Déficit fort (moins de 85%)"
                            }, {
                                MIN_VALUE: 85,
                                MAX_VALUE: 90,
                                REPRESENTATION: "rgba(240,140,140,1)",
                                LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                            }, {
                                MIN_VALUE: 90,
                                MAX_VALUE: 95,
                                REPRESENTATION: "rgba(247,193,193,1)",
                                LEGEND_TEXT: "Déficit faible (90% à 94%)"
                            }, {
                                MIN_VALUE: 95,
                                MAX_VALUE: 100,
                                REPRESENTATION: "rgba(251,225,225,1)",
                                LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                            }, {
                                MIN_VALUE: 100,
                                MAX_VALUE: 106,
                                REPRESENTATION: "rgba(226,239,217,1)",
                                LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                            }, {
                                MIN_VALUE: 106,
                                MAX_VALUE: 111,
                                REPRESENTATION: "rgba(198,224,180,1)",
                                LEGEND_TEXT: "Surplus faible (106% à 110%)"
                            }, {
                                MIN_VALUE: 111,
                                MAX_VALUE: 116,
                                REPRESENTATION: "rgba(160,204,130,1)",
                                LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                            }, {
                                MIN_VALUE: 116,
                                MAX_VALUE: 300,
                                REPRESENTATION: "rgba(117,179,75,1)",
                                LEGEND_TEXT: "Surplus fort (116% et plus)"
                            }]
                        }
                    },
                    {
                        TYPE: "ThemeByRangesOfValues",
                        LAYER_ID: "BC_taux_1",
                        DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                        DATACOLUMN_ID: "c_TAUX_ANTIC",
                        REPRESENTATION_ENUM: "color",
                        AS_OVERLAY: false,
                        ENABLED: true,
                        LEGEND_TEXT: "Taux de couverture 2028 (%)",
                        NUMBER_OF_RANGES: 8,
                        RANGE_CALCULATION_METHOD: "CUSTOM",
                        REVERSE_RANGES: true,
                        REVERSE_REPRESENTATIONS: true,
                        SCHEME: {
                            ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_ST",
                            SCHEME_ELEMENTS: [{
                                MIN_VALUE: 0,
                                MAX_VALUE: 85,
                                REPRESENTATION: "rgba(236,98,98,1)",
                                LEGEND_TEXT: "Déficit fort (moins de 85%)"
                            }, {
                                MIN_VALUE: 85,
                                MAX_VALUE: 90,
                                REPRESENTATION: "rgba(240,140,140,1)",
                                LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                            }, {
                                MIN_VALUE: 90,
                                MAX_VALUE: 95,
                                REPRESENTATION: "rgba(247,193,193,1)",
                                LEGEND_TEXT: "Déficit faible (90% à 94%)"
                            }, {
                                MIN_VALUE: 95,
                                MAX_VALUE: 100,
                                REPRESENTATION: "rgba(251,225,225,1)",
                                LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                            }, {
                                MIN_VALUE: 100,
                                MAX_VALUE: 106,
                                REPRESENTATION: "rgba(226,239,217,1)",
                                LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                            }, {
                                MIN_VALUE: 106,
                                MAX_VALUE: 111,
                                REPRESENTATION: "rgba(198,224,180,1)",
                                LEGEND_TEXT: "Surplus faible (106% à 110%)"
                            }, {
                                MIN_VALUE: 111,
                                MAX_VALUE: 116,
                                REPRESENTATION: "rgba(160,204,130,1)",
                                LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                            }, {
                                MIN_VALUE: 116,
                                MAX_VALUE: 300,
                                REPRESENTATION: "rgba(117,179,75,1)",
                                LEGEND_TEXT: "Surplus fort (116% et plus)"
                            }]
                        }
                    }
                ]
            }, {
                ID : "RESEAU_STATUT_CS",
                TYPE : "ThemeSetGroup",
                TITLE : "Par centre de services scolaire/commissions scolaires à statut particulier et avec présence de classe maternelle 4 ans à temps plein",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "RESEAU_STATUT_CS_689000",
                        TYPE : "ThemeSet",
                        TITLE : "689000 - CSS du Littoral",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_STATUT",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSST_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E03_CS_STA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSST_MAT4ANS", DATATABLE_ID : "t_CSST_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "689000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_STATUT", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "689000"}]},
                                {LAYER_ID : "GEO09E03_CS_STA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E03_CS_STA_GEN", DATACOLUMN_ID : "CD_CS_STA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "689000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_689",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_689",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_STATUT_CS_759000",
                        TYPE : "ThemeSet",
                        TITLE : "759000 - CS crie",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_STATUT",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSST_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E03_CS_STA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSST_MAT4ANS", DATATABLE_ID : "t_CSST_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "759000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_STATUT", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "759000"}]},
                                {LAYER_ID : "GEO09E03_CS_STA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E03_CS_STA_GEN", DATACOLUMN_ID : "CD_CS_STA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "759000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_759",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_759",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }, {
                        ID : "RESEAU_STATUT_CS_769000",
                        TYPE : "ThemeSet",
                        TITLE : "769000 - CS Kativik",
                        SELECTED_DATAVIEW_LAYER : "GEO09E34_GDUNO_ORG_IMM_STATUT",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "CSST_MAT4ANS", VISIBLE : true, LABEL_VISIBLE : false, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT", VISIBLE : true, LABEL_VISIBLE : true, CLUSTERING_ACTIVATED : false},
                                {LAYER_ID : "GEO09E03_CS_STA_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                            ]
                        },
                        THEMESET_DATA_FILTER_SETTINGS : {
                            FILTER_DATA_COLUMNS_SETTINGS : [
                                {LAYER_ID : "CSST_MAT4ANS", DATATABLE_ID : "t_CSST_MAT4ANS", DATACOLUMN_ID : "c_CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "769000"}]},
                                {LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT", DATATABLE_ID : "AttributesDataTable_GEO09E34_GDUNO_ORG_IMM_STATUT", DATACOLUMN_ID : "CD_CS", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "769000"}]},
                                {LAYER_ID : "GEO09E03_CS_STA_GEN", DATATABLE_ID : "AttributesDataTable_GEO09E03_CS_STA_GEN", DATACOLUMN_ID : "CD_CS_STA", DATA_FILTERS : [{TYPE : "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE : "769000"}]}
                            ]
                        },
                        THEMES: [{
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                                DATACOLUMN_ID: "c_TAUX_PRES",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2025 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T20_TAUX_PRES_RANGES_OF_VALUES_769",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            },
                            {
                                TYPE: "ThemeByRangesOfValues",
                                LAYER_ID: "BC_taux_1",
                                DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                                DATACOLUMN_ID: "c_TAUX_ANTIC",
                                REPRESENTATION_ENUM: "color",
                                AS_OVERLAY: false,
                                ENABLED: true,
                                LEGEND_TEXT: "Taux de couverture 2028 (%)",
                                NUMBER_OF_RANGES: 8,
                                RANGE_CALCULATION_METHOD: "CUSTOM",
                                REVERSE_RANGES: true,
                                REVERSE_REPRESENTATIONS: true,
                                SCHEME: {
                                    ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_769",
                                    SCHEME_ELEMENTS: [{
                                        MIN_VALUE: 0,
                                        MAX_VALUE: 85,
                                        REPRESENTATION: "rgba(236,98,98,1)",
                                        LEGEND_TEXT: "Déficit fort (moins de 85%)"
                                    }, {
                                        MIN_VALUE: 85,
                                        MAX_VALUE: 90,
                                        REPRESENTATION: "rgba(240,140,140,1)",
                                        LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                                    }, {
                                        MIN_VALUE: 90,
                                        MAX_VALUE: 95,
                                        REPRESENTATION: "rgba(247,193,193,1)",
                                        LEGEND_TEXT: "Déficit faible (90% à 94%)"
                                    }, {
                                        MIN_VALUE: 95,
                                        MAX_VALUE: 100,
                                        REPRESENTATION: "rgba(251,225,225,1)",
                                        LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                                    }, {
                                        MIN_VALUE: 100,
                                        MAX_VALUE: 106,
                                        REPRESENTATION: "rgba(226,239,217,1)",
                                        LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                                    }, {
                                        MIN_VALUE: 106,
                                        MAX_VALUE: 111,
                                        REPRESENTATION: "rgba(198,224,180,1)",
                                        LEGEND_TEXT: "Surplus faible (106% à 110%)"
                                    }, {
                                        MIN_VALUE: 111,
                                        MAX_VALUE: 116,
                                        REPRESENTATION: "rgba(160,204,130,1)",
                                        LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                                    }, {
                                        MIN_VALUE: 116,
                                        MAX_VALUE: 300,
                                        REPRESENTATION: "rgba(117,179,75,1)",
                                        LEGEND_TEXT: "Surplus fort (116% et plus)"
                                    }]
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    };
});
